import { useEffect, useState } from "react";
import { DateTime } from "luxon";
import { useSearchParams } from "react-router-dom";
import { ReportService } from "../../../services/ReportService";
import PrintButton from "../../../components/buttons/PrintButton";

export default function ReportEscalas() {
  const [searchParams] = useSearchParams();
  const selectedPeriod = searchParams.get("period");

  const [reportData, setReportData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const reportService = new ReportService();

  const periodParts = selectedPeriod ? selectedPeriod.split("-") : [];
  const [month, year] = periodParts.map(Number);

  const isValidPeriod =
    periodParts.length === 2 &&
    !isNaN(month) &&
    !isNaN(year) &&
    month >= 1 &&
    month <= 12;

  useEffect(() => {
    if (!isValidPeriod) return;

    setLoading(true);
    setError("");

    reportService
      .getRelatorioEscalas(selectedPeriod)
      .then((data) => setReportData(data || []))
      .catch(() => setError("Erro ao carregar o relatório."))
      .finally(() => setLoading(false));
  }, [selectedPeriod]);

  const formatDateTime = (date, startDate, endDate) => {
    try {
      const start = DateTime.fromISO(startDate, { zone: "UTC" })
        .setZone("America/Sao_Paulo")
        .setLocale("pt-BR")
        .toFormat("ccc dd/MM/yyyy HH:mm")
        .toUpperCase()
        .replace(/\./, "");

      const end = DateTime.fromISO(endDate, { zone: "UTC" })
        .setZone("America/Sao_Paulo")
        .toFormat("HH:mm");

      return `${start} ÀS ${end}`;
    } catch (error) {
      console.error("Error formatting datetime:", error);
      return "Data inválida";
    }
  };

  const periodDate = DateTime.fromObject({ year, month }, { zone: "America/Sao_Paulo" });

  const monthName = periodDate
    .setLocale("pt-BR")
    .toFormat("MMMM")
    .toUpperCase();
  const startDate = periodDate.startOf("month").toFormat("dd/MM/yyyy");
  const endDate = periodDate.endOf("month").toFormat("dd/MM/yyyy");

  const yearAndMonth = periodDate.toFormat("yyyy-MM");

  return (
    <div>
      <div className="container mt-4">
        <PrintButton
          fileName={`${yearAndMonth} - RELATÓRIO DE ESCALAS DE UNIDADES ESCOLARES`}
        />

        <div className="row">
          <div className="col-3">
            <img src="/logo.png" alt="Logo" width="120" />
          </div>

          <div className="col-9 text-center">
            <h3 className="fw-bold">GAMA - GUARDA MUNICIPAL DE AMERICANA</h3>
            <h3>SISTEMA DE DIÁRIA ADICIONAL POR ESCALA EXTRAORDINÁRIA</h3>
            <h3>RELATÓRIO DE ESCALAS DE UNIDADES ESCOLARES (UE)</h3>
          </div>

          <div
            className="col-12 text-end p-2"
            style={{
              display: "inline-block",
              width: "fit-content",
              marginLeft: "auto",
            }}
          >
            <div className="text-center">
              <strong>
                MÊS {monthName} {year}
              </strong>
            </div>
            <div>
              <span>
                DE: {startDate} A {endDate}
              </span>
            </div>
          </div>
        </div>

        {error && <div className="text-danger mt-3">{error}</div>}
        {loading && <p>Carregando...</p>}

        {reportData.length > 0 && (
          <div className="mt-4">
            {reportData.map((school) => (
              <div key={school.schoolName} className="mb-5">
                <table className="table table-bordered custom-table">
                  <thead>
                    <tr className="school-header bg-secondary text-white">
                      <th colSpan="4" className="text-left school-header">
                        {school.schoolName?.toUpperCase()}
                      </th>
                    </tr>
                    <tr className="bg-secondary text-white">
                      <th>DIA HORA</th>
                      <th>MATRÍCULA GCM</th>
                      <th>NOME</th>
                      <th>STATUS</th>
                    </tr>
                  </thead>
                  <tbody>
                    {school.reservations.map((res, index) => (
                      <tr key={index}>
                        <td>
                          {formatDateTime(res.date, res.startDate, res.endDate)}
                        </td>
                        <td>{res.username}</td>
                        <td>{res.fullName.trim()}</td>
                        <td className={res.canceled ? "fw-bold" : "fw-bold"}>
                          {res.canceled ? "CANCELADO" : "OK"}
                        </td>
                      </tr>
                    ))}
                    <tr className="bg-secondary text-white">
                      <td colSpan="3" className="fw-bold school-header">
                        TOTAL DE HORAS:
                      </td>
                      <td className="fw-bold school-header">
                        {school.totalHours} HORAS
                      </td>
                      {/* <td className="fw-bold school-header">
                        PRINCIPAIS GCM MATRÍCULA:{" "}
                        {school.topGCMs.map((gcm) => gcm).join(", ")}
                      </td> */}
                    </tr>
                  </tbody>
                </table>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
